var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2586 15.8526L28.6474 19.2398L25.2586 15.8526ZM27.4378 12.8685L18.2744 22.0319C17.801 22.5047 17.4781 23.1071 17.3464 23.7631L16.5 28L20.7369 27.152C21.3929 27.0208 21.9945 26.6992 22.4681 26.2256L31.6315 17.0622C31.9068 16.7869 32.1253 16.46 32.2743 16.1002C32.4233 15.7404 32.5 15.3548 32.5 14.9654C32.5 14.576 32.4233 14.1904 32.2743 13.8306C32.1253 13.4708 31.9068 13.1439 31.6315 12.8685C31.3561 12.5932 31.0292 12.3747 30.6694 12.2257C30.3097 12.0767 29.924 12 29.5346 12C29.1452 12 28.7596 12.0767 28.3998 12.2257C28.04 12.3747 27.7132 12.5932 27.4378 12.8685V12.8685Z",
    stroke: "#currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8V32.3636C8.5 33.4682 9.39543 34.3636 10.5 34.3636H17.0113C17.5123 34.3636 17.9951 34.5517 18.3641 34.8906L25.0161 41L31.6681 34.8906C32.0372 34.5517 32.52 34.3636 33.021 34.3636H38.5C39.6046 34.3636 40.5 33.4682 40.5 32.3636V8C40.5 6.89543 39.6046 6 38.5 6H10.5C9.39543 6 8.5 6.89543 8.5 8Z",
    stroke: "#currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3e0a7eac4ea51a89f1b66c236fc5765d.svg";
export { ForwardRef as ReactComponent };